module.exports = __webpack_public_path__ + "img/9788973812899.4a2a0f55.jpg";